import { useTranslation } from 'react-i18next';
import styles from '../Modal.module.scss';

const TranslationWithTicketRef = ({
  link,
  ticketId,
  translateKey,
}: {
  link: string;
  ticketId: string;
  translateKey: string;
}) => {
  const { t } = useTranslation();
  const urlTag = `<a href="${link}" target="_blank" class=${styles.link} rel="noopener noreferrer">#${ticketId}</a>`;

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: t(translateKey, {
          refTicketNumber: urlTag,
        }),
      }}
    />
  );
};

export default TranslationWithTicketRef;
